/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as LoginImport } from './app/routes/login'
import { Route as LayoutMainImport } from './app/routes/_layout-main'
import { Route as LayoutMainIndexImport } from './app/routes/_layout-main/index'
import { Route as LayoutMainProfileImport } from './app/routes/_layout-main/profile'
import { Route as LayoutMainOrdersIndexImport } from './app/routes/_layout-main/orders.index'
import { Route as LayoutMainNewsIndexImport } from './app/routes/_layout-main/news.index'
import { Route as LayoutMainMeterReadingsIndexImport } from './app/routes/_layout-main/meter-readings.index'
import { Route as LayoutMainDealsIndexImport } from './app/routes/_layout-main/deals.index'
import { Route as LayoutMainChargesIndexImport } from './app/routes/_layout-main/charges.index'
import { Route as LayoutMainOrdersCreateImport } from './app/routes/_layout-main/orders.create'
import { Route as LayoutMainOrdersOrderIdImport } from './app/routes/_layout-main/orders.$orderId'
import { Route as LayoutMainNewsNewsIdImport } from './app/routes/_layout-main/news.$newsId'
import { Route as LayoutMainDealsRentAreaIdImport } from './app/routes/_layout-main/deals.$rentAreaId'
import { Route as LayoutMainChargesChargeIdImport } from './app/routes/_layout-main/charges.$chargeId'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./app/routes/login.lazy').then((d) => d.Route))

const LayoutMainRoute = LayoutMainImport.update({
  id: '/_layout-main',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main.lazy').then((d) => d.Route),
)

const LayoutMainIndexRoute = LayoutMainIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/index.lazy').then((d) => d.Route),
)

const LayoutMainProfileRoute = LayoutMainProfileImport.update({
  path: '/profile',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/profile.lazy').then((d) => d.Route),
)

const LayoutMainOrdersIndexRoute = LayoutMainOrdersIndexImport.update({
  path: '/orders/',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/orders.index.lazy').then((d) => d.Route),
)

const LayoutMainNewsIndexRoute = LayoutMainNewsIndexImport.update({
  path: '/news/',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/news.index.lazy').then((d) => d.Route),
)

const LayoutMainMeterReadingsIndexRoute =
  LayoutMainMeterReadingsIndexImport.update({
    path: '/meter-readings/',
    getParentRoute: () => LayoutMainRoute,
  } as any).lazy(() =>
    import('./app/routes/_layout-main/meter-readings.index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutMainDealsIndexRoute = LayoutMainDealsIndexImport.update({
  path: '/deals/',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/deals.index.lazy').then((d) => d.Route),
)

const LayoutMainChargesIndexRoute = LayoutMainChargesIndexImport.update({
  path: '/charges/',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/charges.index.lazy').then((d) => d.Route),
)

const LayoutMainOrdersCreateRoute = LayoutMainOrdersCreateImport.update({
  path: '/orders/create',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/orders.create.lazy').then((d) => d.Route),
)

const LayoutMainOrdersOrderIdRoute = LayoutMainOrdersOrderIdImport.update({
  path: '/orders/$orderId',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/orders.$orderId.lazy').then((d) => d.Route),
)

const LayoutMainNewsNewsIdRoute = LayoutMainNewsNewsIdImport.update({
  path: '/news/$newsId',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/news.$newsId.lazy').then((d) => d.Route),
)

const LayoutMainDealsRentAreaIdRoute = LayoutMainDealsRentAreaIdImport.update({
  path: '/deals/$rentAreaId',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/deals.$rentAreaId.lazy').then(
    (d) => d.Route,
  ),
)

const LayoutMainChargesChargeIdRoute = LayoutMainChargesChargeIdImport.update({
  path: '/charges/$chargeId',
  getParentRoute: () => LayoutMainRoute,
} as any).lazy(() =>
  import('./app/routes/_layout-main/charges.$chargeId.lazy').then(
    (d) => d.Route,
  ),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout-main': {
      preLoaderRoute: typeof LayoutMainImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_layout-main/profile': {
      preLoaderRoute: typeof LayoutMainProfileImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/': {
      preLoaderRoute: typeof LayoutMainIndexImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/charges/$chargeId': {
      preLoaderRoute: typeof LayoutMainChargesChargeIdImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/deals/$rentAreaId': {
      preLoaderRoute: typeof LayoutMainDealsRentAreaIdImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/news/$newsId': {
      preLoaderRoute: typeof LayoutMainNewsNewsIdImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/orders/$orderId': {
      preLoaderRoute: typeof LayoutMainOrdersOrderIdImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/orders/create': {
      preLoaderRoute: typeof LayoutMainOrdersCreateImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/charges/': {
      preLoaderRoute: typeof LayoutMainChargesIndexImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/deals/': {
      preLoaderRoute: typeof LayoutMainDealsIndexImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/meter-readings/': {
      preLoaderRoute: typeof LayoutMainMeterReadingsIndexImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/news/': {
      preLoaderRoute: typeof LayoutMainNewsIndexImport
      parentRoute: typeof LayoutMainImport
    }
    '/_layout-main/orders/': {
      preLoaderRoute: typeof LayoutMainOrdersIndexImport
      parentRoute: typeof LayoutMainImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  LayoutMainRoute.addChildren([
    LayoutMainProfileRoute,
    LayoutMainIndexRoute,
    LayoutMainChargesChargeIdRoute,
    LayoutMainDealsRentAreaIdRoute,
    LayoutMainNewsNewsIdRoute,
    LayoutMainOrdersOrderIdRoute,
    LayoutMainOrdersCreateRoute,
    LayoutMainChargesIndexRoute,
    LayoutMainDealsIndexRoute,
    LayoutMainMeterReadingsIndexRoute,
    LayoutMainNewsIndexRoute,
    LayoutMainOrdersIndexRoute,
  ]),
  LoginRoute,
])

/* prettier-ignore-end */
